import { useEffect, useState } from 'react';

const CYCLE_MS = 2200;

export function useCyclingLabel(labels: readonly string[], isPaused: boolean): string | undefined {
  const [index, setIndex] = useState(0);
  const lastIndex = labels.length - 1;

  useEffect(() => {
    if (isPaused || index >= lastIndex) {
      return;
    }
    const timer = setTimeout(() => setIndex((current) => current + 1), CYCLE_MS);
    return () => clearTimeout(timer);
  }, [isPaused, index, lastIndex]);

  return labels[index];
}
